import type { ReactNode, CSSProperties } from "react";
import "./reactbits.css";

interface GradientTextProps {
  children: ReactNode;
  className?: string;
  /** CSS color stops for the gradient. */
  colors?: string[];
  /** Seconds for one full sweep. */
  animationSpeed?: number;
}

/**
 * ReactBits GradientText — text filled with an animated, looping gradient.
 * Pure CSS (keyframes in reactbits.css); no JS animation cost.
 */
export default function GradientText({
  children,
  className = "",
  colors = ["hsl(var(--primary))", "#8b5cf6", "hsl(var(--primary))"],
  animationSpeed = 8,
}: GradientTextProps) {
  const style: CSSProperties = {
    backgroundImage: `linear-gradient(to right, ${colors.join(", ")})`,
    animationDuration: `${animationSpeed}s`,
  };
  return (
    <span className={`rb-gradient-text ${className}`} style={style}>
      {children}
    </span>
  );
}
